import React, { useState } from "react";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  CircularProgress,
} from "@mui/material";
import { vendorTypeDropdown, validatePan, inputHeight } from "./utils";
import { validateVendorPan } from "./vendorService";

const AddVendorModal = ({ open, onClose, onProceed }) => {
  const [form, setForm] = useState({ vendorType: null, panCardNumber: "" });
  const [panError, setPanError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
    if (key === "panCardNumber") setPanError("");
  };

  const handleClose = () => {
    setForm({ vendorType: null, panCardNumber: "" });
    onClose();
  };

  const isProceedDisabled =
    !form.vendorType?.value ||
    !form.panCardNumber ||
    !validatePan(form.panCardNumber) ||
    loading;

  const handleProceed = async () => {
    setLoading(true);
    setPanError("");
    try {
      const res = await validateVendorPan({
        panCardNumber: form.panCardNumber,
        vendorType: form.vendorType?.value,
      });

      if (res?.code === 200) {
        if (res?.data?.isVendorExists) {
          setPanError("A vendor with this PAN already exists.");
          setLoading(false);
          return;
        }
        onProceed({ ...form });
      } else {
        setPanError(res?.message || "PAN validation failed. Please try again.");
      }
    } catch (error) {
      // failureToast("PAN validation failed. Please try again.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          fontWeight: 700,
          fontSize: 20,
          color: "#262626",
          borderBottom: "1px solid #E0E0E0",
          pb: 2,
        }}
      >
        Add Vendor
      </DialogTitle>

      <DialogContent sx={{ pt: 3, pb: 1 }}>
        {/* Vendor Type */}
        <div className="mb-3">
          <AAutoComplete
            label="Vendor Type *"
            currentValue={form.vendorType}
            items={vendorTypeDropdown}
            isMulti={false}
            handleChange={(value) => handleChange("vendorType", value)}
            height="44px"
            labelStyle={{ color: "#262626" }}
          />
        </div>

        {/* PAN Card Number */}
        <div className="mb-3">
          <AInput
            label="PAN Card No. *"
            value={form.panCardNumber}
            handler={(value) => {
              console.log("Input PAN value:", value);

              handleChange("panCardNumber", value?.toUpperCase());
            }}
            placeholder="AAAAA9999A"
            style={inputHeight}
            maxLength={10}
          />
          {panError && (
            <span style={{ color: "#d32f2f", fontSize: 11 }}>{panError}</span>
          )}
        </div>
      </DialogContent>

      {/* Footer actions */}
      <div
        className="d-flex justify-content-end align-items-center px-3 py-3"
        style={{ borderTop: "1px solid #E0E0E0", gap: 12 }}
      >
        <AButton onClick={handleClose} variant="outline" disabled={loading}>
          Cancel
        </AButton>
        <AButton
          disabled={isProceedDisabled}
          onClick={handleProceed}
          variant="primary_filled"
        >
          {loading ? (
            <span className="d-flex align-items-center" style={{ gap: 6 }}>
              <CircularProgress size={14} color="inherit" />
              Validating...
            </span>
          ) : (
            "Proceed"
          )}
        </AButton>
      </div>
    </Dialog>
  );
};

export default AddVendorModal;
